import React from 'react';
import Component from '../component/Component';
import ProgressBar from '../progressbar/ProgressBar';
import { IndicatorState } from './Types';

class Indicator extends Component<{}, IndicatorState> {
  state: IndicatorState = {
    activeDownloadCount: -1,
    inProgress: false
  };

  /**
   * Updates inProgress state.
   * @param processingFinished
   * @param activeDownloadCount
   */
  updateDownloadProcess = (processingFinished: boolean, activeDownloadCount: number) => {
    this.setState({
      activeDownloadCount,
      inProgress: activeDownloadCount > 0 || !processingFinished
    });
  };

  /**
   * Gets indicator content.
   */
  private getContent = () => {
    const { activeDownloadCount, inProgress } = this.state;
    let content = this.translate(activeDownloadCount === -1 ? 'waitingForDownload' : 'downloadCompleted');
    if (inProgress && activeDownloadCount > 0) {
      content = this.translate('downloadInProgress', { activeDownloadCount });
    }
    return content;
  };

  /**
   * Gets progress bar if `inProgress` is `true`.
   */
  private getProgressBar = () => {
    let { inProgress, activeDownloadCount } = this.state;
    return inProgress && activeDownloadCount > 0 ? <ProgressBar
      infiniteAnimate={true}
      hidePercentage={true}
    /> : null;
  };

  render = () => (
    <div className={'tp-widget-download-wrap'}>
      <span
        // <debug>
        data-cy={'download-indicator-label'}
        // </debug>
        className={'tp-widget-download-label'}
      >
        {this.getContent()}
      </span>
      {this.getProgressBar()}
    </div>
  );
}

export default Indicator;
